/**
 *
 */
const groundSellerName = (sl_ground_seller_total, sl_ground_seller_curr) =>
    [
        sl_ground_seller_curr.hr_employee.names,
        sl_ground_seller_curr.hr_employee.last_name1,
    ].join(' ')

//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'rut',
        value: 'rut',
        format: 'rut',
        sortable: true,
    },
    {
        text: 'cliente',
        value: 'alias_name',
    },
    {
        text: 'Habilitado',
        value: ({ blocked_sales }) => !blocked_sales,
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'vendedor asignado',
        value: ({ sl_ground_seller }) =>
            sl_ground_seller.reduce(groundSellerName, '-'),
    },
    {
        text: 'Morosidad',
        value: ({ status }) => status && status.label,
        align: 'center',
    },
    {
        text: 'Monto',
        align: 'right',
        format: 'currency',
        value: 'balance',
    },
    {
        text: 'modificado',
        sortable: true,
        align: 'right',
        format: 'datetime',
        value: 'updated_at',
    },
]
